import { FC, ReactElement } from 'react';

import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { Icon } from '../../../../components';
import { NavigationGroup } from '../../../../entities/@navigation/Navigation/Navigation';

import './FooterNavigationGroup.scss';

interface FooterNavigationGroupProps {
    label: string;
    groups: NavigationGroup[];
    hideHeader?: boolean;
    layoutIsRow?: boolean;
    className?: string;
}

export const FooterNavigationGroup: FC<FooterNavigationGroupProps> = ({
    label,
    groups,
    hideHeader,
    layoutIsRow,
    className = '',
}): ReactElement => {
    const listClassNames = classNames('footer-navigation-group__list', {
        'footer-navigation-group__list--layout-is-row': layoutIsRow,
    });

    return (
        <nav
            aria-label={label}
            className={`footer-navigation-group ${className}`}
        >
            {hideHeader && (
                <h2 className="footer-navigation-group__title">
                    {label}
                </h2>
            )}

            {groups.map(group => (
                <ul key={group.id} className={listClassNames}>
                    {group.items.map(item => {
                        const itemClassName = classNames('footer-navigation-group__item', {
                            'footer-navigation-group__item--with-icon': item.icon,
                        });

                        return (
                            <li key={item.id} className={itemClassName}>
                                <Link
                                    aria-label={item.label}
                                    to={item.to}
                                    target={item.target}
                                    className="footer-navigation-group__link"
                                >
                                    {item.icon ? (
                                        <Icon name={item.icon} className="footer-navigation-group__link-icon" />
                                    ) : (
                                        item.label
                                    )}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            ))}
        </nav>
    );
};
